<template>
<p class="text-primary">
{{getOptionValue()}}
</p>
</template>

<script>
export default {

  name: 'ColumnSelectValue',
  props:["value","column_id","columns"],
  data () {
    return {

    }
  },
  computed:{
  	preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:{
  	preflang_id(newval)
    {
    	this.getOptionValue()
    },
  },
  methods:{
  	getOptionValue()
  	{
  		let column = this.columns.find((item)=>{return item.id == this.column_id})      
      	let option = column.options.find((item)=>{return item.id == this.value})
      	return this.getTheTranslation(option,"translation")
  	},
  }
}
</script>

<style lang="css" scoped>
</style>